import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './blog-comments.reducer';

export const BlogCommentsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const blogCommentsEntity = useAppSelector(state => state.blogComments.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="blogCommentsDetailsHeading">
          <Translate contentKey="reachamyApp.blogComments.detail.title">BlogComments</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{blogCommentsEntity.id}</dd>
          <dt>
            <span id="userID">
              <Translate contentKey="reachamyApp.blogComments.userID">User ID</Translate>
            </span>
          </dt>
          <dd>{blogCommentsEntity.userID}</dd>
          <dt>
            <span id="replyToMessage">
              <Translate contentKey="reachamyApp.blogComments.replyToMessage">Reply To Message</Translate>
            </span>
          </dt>
          <dd>{blogCommentsEntity.replyToMessage}</dd>
          <dt>
            <span id="imageUrl">
              <Translate contentKey="reachamyApp.blogComments.imageUrl">Image Url</Translate>
            </span>
          </dt>
          <dd>{blogCommentsEntity.imageUrl}</dd>
          <dt>
            <span id="createdAt">
              <Translate contentKey="reachamyApp.blogComments.createdAt">Created At</Translate>
            </span>
          </dt>
          <dd>
            {blogCommentsEntity.createdAt ? <TextFormat value={blogCommentsEntity.createdAt} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="updatedAt">
              <Translate contentKey="reachamyApp.blogComments.updatedAt">Updated At</Translate>
            </span>
          </dt>
          <dd>
            {blogCommentsEntity.updatedAt ? <TextFormat value={blogCommentsEntity.updatedAt} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
        </dl>
        <Button tag={Link} to="/blog-comments" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/blog-comments/${blogCommentsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BlogCommentsDetail;
